module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "my-orders-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v("\n        Loading your orders...\n      ")]) : (_vm.error) ? _c('div', {
    staticClass: "error-state"
  }, [_c('div', {
    staticClass: "error-icon"
  }, [_vm._v("⚠️")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])]) : (_vm.orders.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('div', {
    staticClass: "empty-icon"
  }, [_vm._v("📦")]), _vm._v(" "), _c('h2', [_vm._v("No orders yet")]), _vm._v(" "), _c('p', [_vm._v("You haven't placed any orders yet. Start shopping!")]), _vm._v(" "), _c('button', {
    staticClass: "btn-shop",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n          Browse Products\n        ")])]) : _c('div', {
    staticClass: "orders-list"
  }, _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order.id,
      staticClass: "order-card",
      on: {
        "click": function($event) {
          _vm.viewOrder(order.id)
        }
      }
    }, [_c('div', {
      staticClass: "order-header"
    }, [_c('div', {
      staticClass: "order-info"
    }, [_c('h3', [_vm._v("Order #" + _vm._s(order.order_number))]), _vm._v(" "), _c('p', {
      staticClass: "order-date"
    }, [_vm._v(_vm._s(_vm.formatDate(order.created_at)))])]), _vm._v(" "), _c('div', {
      staticClass: "order-status"
    }, [_c('span', {
      class: ['status-badge', order.status]
    }, [_vm._v("\n                " + _vm._s(_vm.formatStatus(order.status)) + "\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "order-items-preview"
    }, [_vm._l((order.items.slice(0, 3)), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "item-preview"
      }, [_c('div', {
        staticClass: "item-image-small"
      }, [(item.product && item.product.images && item.product.images.length > 0) ? _c('img', {
        attrs: {
          "src": _vm.getPrimaryImage(item.product).image_url,
          "alt": item.product_name
        }
      }) : _c('div', {
        staticClass: "no-image-small"
      }, [_vm._v("?")])])])
    }), _vm._v(" "), (order.items.length > 3) ? _c('span', {
      staticClass: "more-items"
    }, [_vm._v("\n              +" + _vm._s(order.items.length - 3) + " more\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "order-footer"
    }, [_c('div', {
      staticClass: "order-total"
    }, [_c('span', {
      staticClass: "total-label"
    }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
      staticClass: "total-amount"
    }, [_vm._v("$" + _vm._s(_vm.formatPrice(order.total_cents)))])]), _vm._v(" "), _c('button', {
      staticClass: "btn-view",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.viewOrder(order.id)
        }
      }
    }, [_vm._v("\n              View Details →\n            ")])])])
  }))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("My Orders")]), _vm._v(" "), _c('p', [_vm._v("View and track your order history")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fe6f42e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MyOrders.vue
// module id = 282
// module chunks = 1